import styled from 'styled-components';

import Button from '@components/Button/next';
import Input from '@components/Input';

export const Container = styled.div<{ visible?: boolean }>`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000000000; // need this huge value to bypass the CookiebotWidget z-index
  transition: all 0.15s;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChatGPTModalContent = styled.div<{ visible?: boolean }>`
  position: relative;
  width: 900px;
  height: 600px; // 500 can be used to avoid overflow for small screens
  z-index: 100000;
  transition: all 0.15s;
  box-shadow: 0px 10px 20px rgba(58, 58, 58, 0.1);
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100vw;
    min-height: 100vh; // needed as a fallback in case -webkit-fill-available is not supported
    min-height: -webkit-fill-available; // needed to prevent scroll on mobile
    right: 0;
    bottom: 0;
    top: 0;
  }
`;

export const Header = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  box-shadow: 0px 10px 20px 0px rgba(58, 58, 58, 0.1);
  z-index: 1;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 24px 16px;
  }
`;

export const Main = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 24px 10px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  margin-right: 10px;

  ::-webkit-scrollbar {
    width: 5px;
    background-color: ${({ theme }) => theme.palette.gray};
    border-color: black;
  }
  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.gray87};
    border-color: black;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
    border-color: black;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 24px 16px 0 16px;
    margin-right: 0;

    ::-webkit-scrollbar {
      width: 0;
      visibility: hidden;
    }
  }
`;

export const UserMessage = styled.div`
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 10px;
  border-radius: 8px;
  width: 60%;
  align-self: flex-end;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 90%;
  }
`;

export const AssistantMessage = styled.div`
  background-color: ${({ theme }) => theme.palette.R600};
  padding: 10px;
  border-radius: 8px;
  display: flex;
  gap: 4px;
  max-width: 70%;
  align-items: flex-start;

  & > p {
    height: fit-content;
    margin-top: 2px;
  }

  & span {
    margin-top: -3px;
  }

  & a {
    color: ${({ theme }) => theme.palette.NL0};
    text-decoration: underline;
    font-weight: bold;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 90%;
  }
`;

export const AssistantMessageLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  gap: 4px;
`;

export const Footer = styled.div`
  height: 107px;
  display: grid;
  grid-template-columns: 1fr 72px;
  column-gap: 24px;
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.palette.NL0};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr 44px;
    column-gap: 12px;
    padding: 12px;
    height: 74px;
  }
`;

export const UserQuestionInput = styled(Input)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 50px;
  }
`;

export const SendQuestionButton = styled(Button)`
  height: 100%;
  width: 100%;
  padding: 17px 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px;
  }
`;

export const ChatGPTButton = styled.button`
  border: none;
  z-index: 101;
  position: fixed;
  bottom: 85px;
  right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  line-height: 20px;
  transition: all 0.45s;
  padding: 0;
  border-radius: 50%;
  box-shadow: 0px 0px 20px rgba(58, 58, 58, 0.3);
`;
